export enum StringFormatType {
    UPPER = 'upper',
    LOWER = 'lower',
}
